import {
  House,
  ListBullets,
  Receipt,
  ShoppingBag,
  UserCircle
} from "@phosphor-icons/react";
import { NavLink } from "react-router-dom";
import { useCart } from "../../context/CartContext";

const navItems = [
  { to: "/app/home", label: "Главная", icon: House },
  { to: "/app/menu", label: "Меню", icon: ListBullets },
  { to: "/app/cart", label: "Корзина", icon: ShoppingBag },
  { to: "/app/orders", label: "Заказы", icon: Receipt },
  { to: "/app/profile", label: "Профиль", icon: UserCircle }
] as const;

export function AppBottomNav() {
  const { itemCount } = useCart();

  return (
    <nav className="pointer-events-none fixed inset-x-0 bottom-0 z-40 flex justify-center px-3 pb-[max(0.9rem,env(safe-area-inset-bottom))] md:absolute md:left-1/2 md:w-full md:max-w-[430px] md:-translate-x-1/2">
      <div className="app-bottom-nav-surface pointer-events-auto grid w-full max-w-[430px] grid-cols-5 gap-2 rounded-[2rem] border border-white/70 bg-[rgba(247,241,231,0.9)] p-2 shadow-[0_26px_54px_-34px_rgba(27,53,52,0.58)] backdrop-blur-2xl">
        {navItems.map((item) => {
          const Icon = item.icon;

          return (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                [
                  "relative flex min-h-16 flex-col items-center justify-center gap-1 rounded-[1.35rem] px-2 py-2 text-[0.72rem] font-medium tracking-tight transition duration-300 active:scale-[0.98]",
                  isActive
                    ? "bg-teal-700 text-stone-50 shadow-[0_18px_32px_-24px_rgba(21,93,95,0.76)]"
                    : "text-stone-500 hover:bg-white/70 hover:text-stone-950"
                ].join(" ")
              }
            >
              {({ isActive }) => (
                <>
                  <div className="relative">
                    <Icon size={20} weight={isActive ? "fill" : "regular"} />
                    {item.to === "/app/cart" && itemCount > 0 ? (
                      <span className="absolute -right-2 -top-2 grid h-5 min-w-5 place-items-center rounded-full bg-stone-950 px-1 text-[0.62rem] font-semibold text-stone-50">
                        {itemCount}
                      </span>
                    ) : null}
                  </div>
                  <span>{item.label}</span>
                </>
              )}
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
